// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.5
// source: roboverse_platform_protos/statekeeping/Reported/MissionStatus.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Duration } from "../../../google/protobuf/duration";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Pose } from "../Common/Geometry";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported";

export interface MissionStatus {
  /**
   * bool isRunning = 1;
   * bool lastMissionSuccesful = 2;
   * int32 missionPlanId = 3;
   * int32 missionSessionId = 4;
   * string statusMessage =5;
   */
  missionId: string;
  mapId: string;
  mapName: string;
  currentActionMetadata: MissionStatus_MissionActionMetadata | undefined;
  navigationProgress: MissionStatus_NavigationProgress | undefined;
  navigationState: MissionStatus_StateInformation | undefined;
  impairedState: MissionStatus_StateInformation | undefined;
  routeTrackingState: MissionStatus_StateInformation | undefined;
  pathTrackingState: MissionStatus_StateInformation | undefined;
  blockageState: MissionStatus_StateInformation | undefined;
  stuckState: MissionStatus_StateInformation | undefined;
  missionStartTime: Date | undefined;
  missionDuration: Duration | undefined;
  lastUpdatedTime: Date | undefined;
  missionExecutorFeedback: string;
}

export interface MissionStatus_MissionActionMetadata {
  actionId: string;
  actionName: string;
  waypointId: string;
  actionLocation: Pose | undefined;
  actionExecutedAt: Date | undefined;
  actionDuration: Duration | undefined;
  success: boolean;
  message: string;
}

export interface MissionStatus_NavigationProgress {
  plannedRoute: string[];
  progressPercentageToAction: number;
  currentNavigatingWaypointId: string;
  currentRobotLocation: Pose | undefined;
  completedRoute: string[];
  remainingRoute: string[];
  remainingDistance: number;
}

export interface MissionStatus_StateInformation {
  status: string;
  statusDescription: string;
}

function createBaseMissionStatus(): MissionStatus {
  return {
    missionId: "",
    mapId: "",
    mapName: "",
    currentActionMetadata: undefined,
    navigationProgress: undefined,
    navigationState: undefined,
    impairedState: undefined,
    routeTrackingState: undefined,
    pathTrackingState: undefined,
    blockageState: undefined,
    stuckState: undefined,
    missionStartTime: undefined,
    missionDuration: undefined,
    lastUpdatedTime: undefined,
    missionExecutorFeedback: "",
  };
}

export const MissionStatus: MessageFns<MissionStatus> = {
  encode(message: MissionStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.missionId !== "") {
      writer.uint32(10).string(message.missionId);
    }
    if (message.mapId !== "") {
      writer.uint32(18).string(message.mapId);
    }
    if (message.mapName !== "") {
      writer.uint32(26).string(message.mapName);
    }
    if (message.currentActionMetadata !== undefined) {
      MissionStatus_MissionActionMetadata.encode(message.currentActionMetadata, writer.uint32(34).fork()).join();
    }
    if (message.navigationProgress !== undefined) {
      MissionStatus_NavigationProgress.encode(message.navigationProgress, writer.uint32(42).fork()).join();
    }
    if (message.navigationState !== undefined) {
      MissionStatus_StateInformation.encode(message.navigationState, writer.uint32(50).fork()).join();
    }
    if (message.impairedState !== undefined) {
      MissionStatus_StateInformation.encode(message.impairedState, writer.uint32(58).fork()).join();
    }
    if (message.routeTrackingState !== undefined) {
      MissionStatus_StateInformation.encode(message.routeTrackingState, writer.uint32(66).fork()).join();
    }
    if (message.pathTrackingState !== undefined) {
      MissionStatus_StateInformation.encode(message.pathTrackingState, writer.uint32(74).fork()).join();
    }
    if (message.blockageState !== undefined) {
      MissionStatus_StateInformation.encode(message.blockageState, writer.uint32(82).fork()).join();
    }
    if (message.stuckState !== undefined) {
      MissionStatus_StateInformation.encode(message.stuckState, writer.uint32(90).fork()).join();
    }
    if (message.missionStartTime !== undefined) {
      Timestamp.encode(toTimestamp(message.missionStartTime), writer.uint32(98).fork()).join();
    }
    if (message.missionDuration !== undefined) {
      Duration.encode(message.missionDuration, writer.uint32(106).fork()).join();
    }
    if (message.lastUpdatedTime !== undefined) {
      Timestamp.encode(toTimestamp(message.lastUpdatedTime), writer.uint32(114).fork()).join();
    }
    if (message.missionExecutorFeedback !== "") {
      writer.uint32(122).string(message.missionExecutorFeedback);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MissionStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.missionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mapId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mapName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.currentActionMetadata = MissionStatus_MissionActionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.navigationProgress = MissionStatus_NavigationProgress.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.navigationState = MissionStatus_StateInformation.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.impairedState = MissionStatus_StateInformation.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.routeTrackingState = MissionStatus_StateInformation.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.pathTrackingState = MissionStatus_StateInformation.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.blockageState = MissionStatus_StateInformation.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.stuckState = MissionStatus_StateInformation.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.missionStartTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.missionDuration = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.lastUpdatedTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.missionExecutorFeedback = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionStatus {
    return {
      missionId: isSet(object.missionId) ? globalThis.String(object.missionId) : "",
      mapId: isSet(object.mapId) ? globalThis.String(object.mapId) : "",
      mapName: isSet(object.mapName) ? globalThis.String(object.mapName) : "",
      currentActionMetadata: isSet(object.currentActionMetadata)
        ? MissionStatus_MissionActionMetadata.fromJSON(object.currentActionMetadata)
        : undefined,
      navigationProgress: isSet(object.navigationProgress)
        ? MissionStatus_NavigationProgress.fromJSON(object.navigationProgress)
        : undefined,
      navigationState: isSet(object.navigationState)
        ? MissionStatus_StateInformation.fromJSON(object.navigationState)
        : undefined,
      impairedState: isSet(object.impairedState)
        ? MissionStatus_StateInformation.fromJSON(object.impairedState)
        : undefined,
      routeTrackingState: isSet(object.routeTrackingState)
        ? MissionStatus_StateInformation.fromJSON(object.routeTrackingState)
        : undefined,
      pathTrackingState: isSet(object.pathTrackingState)
        ? MissionStatus_StateInformation.fromJSON(object.pathTrackingState)
        : undefined,
      blockageState: isSet(object.blockageState)
        ? MissionStatus_StateInformation.fromJSON(object.blockageState)
        : undefined,
      stuckState: isSet(object.stuckState) ? MissionStatus_StateInformation.fromJSON(object.stuckState) : undefined,
      missionStartTime: isSet(object.missionStartTime) ? fromJsonTimestamp(object.missionStartTime) : undefined,
      missionDuration: isSet(object.missionDuration) ? Duration.fromJSON(object.missionDuration) : undefined,
      lastUpdatedTime: isSet(object.lastUpdatedTime) ? fromJsonTimestamp(object.lastUpdatedTime) : undefined,
      missionExecutorFeedback: isSet(object.missionExecutorFeedback)
        ? globalThis.String(object.missionExecutorFeedback)
        : "",
    };
  },

  toJSON(message: MissionStatus): unknown {
    const obj: any = {};
    if (message.missionId !== "") {
      obj.missionId = message.missionId;
    }
    if (message.mapId !== "") {
      obj.mapId = message.mapId;
    }
    if (message.mapName !== "") {
      obj.mapName = message.mapName;
    }
    if (message.currentActionMetadata !== undefined) {
      obj.currentActionMetadata = MissionStatus_MissionActionMetadata.toJSON(message.currentActionMetadata);
    }
    if (message.navigationProgress !== undefined) {
      obj.navigationProgress = MissionStatus_NavigationProgress.toJSON(message.navigationProgress);
    }
    if (message.navigationState !== undefined) {
      obj.navigationState = MissionStatus_StateInformation.toJSON(message.navigationState);
    }
    if (message.impairedState !== undefined) {
      obj.impairedState = MissionStatus_StateInformation.toJSON(message.impairedState);
    }
    if (message.routeTrackingState !== undefined) {
      obj.routeTrackingState = MissionStatus_StateInformation.toJSON(message.routeTrackingState);
    }
    if (message.pathTrackingState !== undefined) {
      obj.pathTrackingState = MissionStatus_StateInformation.toJSON(message.pathTrackingState);
    }
    if (message.blockageState !== undefined) {
      obj.blockageState = MissionStatus_StateInformation.toJSON(message.blockageState);
    }
    if (message.stuckState !== undefined) {
      obj.stuckState = MissionStatus_StateInformation.toJSON(message.stuckState);
    }
    if (message.missionStartTime !== undefined) {
      obj.missionStartTime = message.missionStartTime.toISOString();
    }
    if (message.missionDuration !== undefined) {
      obj.missionDuration = Duration.toJSON(message.missionDuration);
    }
    if (message.lastUpdatedTime !== undefined) {
      obj.lastUpdatedTime = message.lastUpdatedTime.toISOString();
    }
    if (message.missionExecutorFeedback !== "") {
      obj.missionExecutorFeedback = message.missionExecutorFeedback;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionStatus>, I>>(base?: I): MissionStatus {
    return MissionStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionStatus>, I>>(object: I): MissionStatus {
    const message = createBaseMissionStatus();
    message.missionId = object.missionId ?? "";
    message.mapId = object.mapId ?? "";
    message.mapName = object.mapName ?? "";
    message.currentActionMetadata =
      (object.currentActionMetadata !== undefined && object.currentActionMetadata !== null)
        ? MissionStatus_MissionActionMetadata.fromPartial(object.currentActionMetadata)
        : undefined;
    message.navigationProgress = (object.navigationProgress !== undefined && object.navigationProgress !== null)
      ? MissionStatus_NavigationProgress.fromPartial(object.navigationProgress)
      : undefined;
    message.navigationState = (object.navigationState !== undefined && object.navigationState !== null)
      ? MissionStatus_StateInformation.fromPartial(object.navigationState)
      : undefined;
    message.impairedState = (object.impairedState !== undefined && object.impairedState !== null)
      ? MissionStatus_StateInformation.fromPartial(object.impairedState)
      : undefined;
    message.routeTrackingState = (object.routeTrackingState !== undefined && object.routeTrackingState !== null)
      ? MissionStatus_StateInformation.fromPartial(object.routeTrackingState)
      : undefined;
    message.pathTrackingState = (object.pathTrackingState !== undefined && object.pathTrackingState !== null)
      ? MissionStatus_StateInformation.fromPartial(object.pathTrackingState)
      : undefined;
    message.blockageState = (object.blockageState !== undefined && object.blockageState !== null)
      ? MissionStatus_StateInformation.fromPartial(object.blockageState)
      : undefined;
    message.stuckState = (object.stuckState !== undefined && object.stuckState !== null)
      ? MissionStatus_StateInformation.fromPartial(object.stuckState)
      : undefined;
    message.missionStartTime = object.missionStartTime ?? undefined;
    message.missionDuration = (object.missionDuration !== undefined && object.missionDuration !== null)
      ? Duration.fromPartial(object.missionDuration)
      : undefined;
    message.lastUpdatedTime = object.lastUpdatedTime ?? undefined;
    message.missionExecutorFeedback = object.missionExecutorFeedback ?? "";
    return message;
  },
};

function createBaseMissionStatus_MissionActionMetadata(): MissionStatus_MissionActionMetadata {
  return {
    actionId: "",
    actionName: "",
    waypointId: "",
    actionLocation: undefined,
    actionExecutedAt: undefined,
    actionDuration: undefined,
    success: false,
    message: "",
  };
}

export const MissionStatus_MissionActionMetadata: MessageFns<MissionStatus_MissionActionMetadata> = {
  encode(message: MissionStatus_MissionActionMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.actionId !== "") {
      writer.uint32(10).string(message.actionId);
    }
    if (message.actionName !== "") {
      writer.uint32(18).string(message.actionName);
    }
    if (message.waypointId !== "") {
      writer.uint32(26).string(message.waypointId);
    }
    if (message.actionLocation !== undefined) {
      Pose.encode(message.actionLocation, writer.uint32(34).fork()).join();
    }
    if (message.actionExecutedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.actionExecutedAt), writer.uint32(42).fork()).join();
    }
    if (message.actionDuration !== undefined) {
      Duration.encode(message.actionDuration, writer.uint32(50).fork()).join();
    }
    if (message.success !== false) {
      writer.uint32(56).bool(message.success);
    }
    if (message.message !== "") {
      writer.uint32(66).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MissionStatus_MissionActionMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionStatus_MissionActionMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.actionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.actionName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.waypointId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actionLocation = Pose.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.actionExecutedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.actionDuration = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionStatus_MissionActionMetadata {
    return {
      actionId: isSet(object.actionId) ? globalThis.String(object.actionId) : "",
      actionName: isSet(object.actionName) ? globalThis.String(object.actionName) : "",
      waypointId: isSet(object.waypointId) ? globalThis.String(object.waypointId) : "",
      actionLocation: isSet(object.actionLocation) ? Pose.fromJSON(object.actionLocation) : undefined,
      actionExecutedAt: isSet(object.actionExecutedAt) ? fromJsonTimestamp(object.actionExecutedAt) : undefined,
      actionDuration: isSet(object.actionDuration) ? Duration.fromJSON(object.actionDuration) : undefined,
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: MissionStatus_MissionActionMetadata): unknown {
    const obj: any = {};
    if (message.actionId !== "") {
      obj.actionId = message.actionId;
    }
    if (message.actionName !== "") {
      obj.actionName = message.actionName;
    }
    if (message.waypointId !== "") {
      obj.waypointId = message.waypointId;
    }
    if (message.actionLocation !== undefined) {
      obj.actionLocation = Pose.toJSON(message.actionLocation);
    }
    if (message.actionExecutedAt !== undefined) {
      obj.actionExecutedAt = message.actionExecutedAt.toISOString();
    }
    if (message.actionDuration !== undefined) {
      obj.actionDuration = Duration.toJSON(message.actionDuration);
    }
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionStatus_MissionActionMetadata>, I>>(
    base?: I,
  ): MissionStatus_MissionActionMetadata {
    return MissionStatus_MissionActionMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionStatus_MissionActionMetadata>, I>>(
    object: I,
  ): MissionStatus_MissionActionMetadata {
    const message = createBaseMissionStatus_MissionActionMetadata();
    message.actionId = object.actionId ?? "";
    message.actionName = object.actionName ?? "";
    message.waypointId = object.waypointId ?? "";
    message.actionLocation = (object.actionLocation !== undefined && object.actionLocation !== null)
      ? Pose.fromPartial(object.actionLocation)
      : undefined;
    message.actionExecutedAt = object.actionExecutedAt ?? undefined;
    message.actionDuration = (object.actionDuration !== undefined && object.actionDuration !== null)
      ? Duration.fromPartial(object.actionDuration)
      : undefined;
    message.success = object.success ?? false;
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseMissionStatus_NavigationProgress(): MissionStatus_NavigationProgress {
  return {
    plannedRoute: [],
    progressPercentageToAction: 0,
    currentNavigatingWaypointId: "",
    currentRobotLocation: undefined,
    completedRoute: [],
    remainingRoute: [],
    remainingDistance: 0,
  };
}

export const MissionStatus_NavigationProgress: MessageFns<MissionStatus_NavigationProgress> = {
  encode(message: MissionStatus_NavigationProgress, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.plannedRoute) {
      writer.uint32(10).string(v!);
    }
    if (message.progressPercentageToAction !== 0) {
      writer.uint32(17).double(message.progressPercentageToAction);
    }
    if (message.currentNavigatingWaypointId !== "") {
      writer.uint32(26).string(message.currentNavigatingWaypointId);
    }
    if (message.currentRobotLocation !== undefined) {
      Pose.encode(message.currentRobotLocation, writer.uint32(34).fork()).join();
    }
    for (const v of message.completedRoute) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.remainingRoute) {
      writer.uint32(50).string(v!);
    }
    if (message.remainingDistance !== 0) {
      writer.uint32(57).double(message.remainingDistance);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MissionStatus_NavigationProgress {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionStatus_NavigationProgress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.plannedRoute.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.progressPercentageToAction = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.currentNavigatingWaypointId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.currentRobotLocation = Pose.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.completedRoute.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.remainingRoute.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.remainingDistance = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionStatus_NavigationProgress {
    return {
      plannedRoute: globalThis.Array.isArray(object?.plannedRoute)
        ? object.plannedRoute.map((e: any) => globalThis.String(e))
        : [],
      progressPercentageToAction: isSet(object.progressPercentageToAction)
        ? globalThis.Number(object.progressPercentageToAction)
        : 0,
      currentNavigatingWaypointId: isSet(object.currentNavigatingWaypointId)
        ? globalThis.String(object.currentNavigatingWaypointId)
        : "",
      currentRobotLocation: isSet(object.currentRobotLocation) ? Pose.fromJSON(object.currentRobotLocation) : undefined,
      completedRoute: globalThis.Array.isArray(object?.completedRoute)
        ? object.completedRoute.map((e: any) => globalThis.String(e))
        : [],
      remainingRoute: globalThis.Array.isArray(object?.remainingRoute)
        ? object.remainingRoute.map((e: any) => globalThis.String(e))
        : [],
      remainingDistance: isSet(object.remainingDistance) ? globalThis.Number(object.remainingDistance) : 0,
    };
  },

  toJSON(message: MissionStatus_NavigationProgress): unknown {
    const obj: any = {};
    if (message.plannedRoute?.length) {
      obj.plannedRoute = message.plannedRoute;
    }
    if (message.progressPercentageToAction !== 0) {
      obj.progressPercentageToAction = message.progressPercentageToAction;
    }
    if (message.currentNavigatingWaypointId !== "") {
      obj.currentNavigatingWaypointId = message.currentNavigatingWaypointId;
    }
    if (message.currentRobotLocation !== undefined) {
      obj.currentRobotLocation = Pose.toJSON(message.currentRobotLocation);
    }
    if (message.completedRoute?.length) {
      obj.completedRoute = message.completedRoute;
    }
    if (message.remainingRoute?.length) {
      obj.remainingRoute = message.remainingRoute;
    }
    if (message.remainingDistance !== 0) {
      obj.remainingDistance = message.remainingDistance;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionStatus_NavigationProgress>, I>>(
    base?: I,
  ): MissionStatus_NavigationProgress {
    return MissionStatus_NavigationProgress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionStatus_NavigationProgress>, I>>(
    object: I,
  ): MissionStatus_NavigationProgress {
    const message = createBaseMissionStatus_NavigationProgress();
    message.plannedRoute = object.plannedRoute?.map((e) => e) || [];
    message.progressPercentageToAction = object.progressPercentageToAction ?? 0;
    message.currentNavigatingWaypointId = object.currentNavigatingWaypointId ?? "";
    message.currentRobotLocation = (object.currentRobotLocation !== undefined && object.currentRobotLocation !== null)
      ? Pose.fromPartial(object.currentRobotLocation)
      : undefined;
    message.completedRoute = object.completedRoute?.map((e) => e) || [];
    message.remainingRoute = object.remainingRoute?.map((e) => e) || [];
    message.remainingDistance = object.remainingDistance ?? 0;
    return message;
  },
};

function createBaseMissionStatus_StateInformation(): MissionStatus_StateInformation {
  return { status: "", statusDescription: "" };
}

export const MissionStatus_StateInformation: MessageFns<MissionStatus_StateInformation> = {
  encode(message: MissionStatus_StateInformation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.statusDescription !== "") {
      writer.uint32(18).string(message.statusDescription);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MissionStatus_StateInformation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionStatus_StateInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.statusDescription = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionStatus_StateInformation {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      statusDescription: isSet(object.statusDescription) ? globalThis.String(object.statusDescription) : "",
    };
  },

  toJSON(message: MissionStatus_StateInformation): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.statusDescription !== "") {
      obj.statusDescription = message.statusDescription;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionStatus_StateInformation>, I>>(base?: I): MissionStatus_StateInformation {
    return MissionStatus_StateInformation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionStatus_StateInformation>, I>>(
    object: I,
  ): MissionStatus_StateInformation {
    const message = createBaseMissionStatus_StateInformation();
    message.status = object.status ?? "";
    message.statusDescription = object.statusDescription ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
